import React from 'react'
import Header from '../../components/Header/Header';
import RecurPlanDetails from '../../components/RecurPlanDetails/RecurPlanDetails';
function RecurPlanDetailsPage() {
  return (
    <Header activeRoute="/RecurringPlans">
      <RecurPlanDetails/>
    </Header>
  )
}

export default RecurPlanDetailsPage
